import React from 'react';
import { useTranslation } from 'react-i18next';
import ExternalMessageModal from './external-message-modal';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignIn } from '@fortawesome/pro-regular-svg-icons';
import { LOGIN } from '../../../router/routes';
import css from '../../../components/modals/modal.module.css';

interface Props {
  onClose: () => void;
}

export default function FarmAlreadyExistsModal({ onClose }: Props) {
  const { t } = useTranslation();

  return (
    <ExternalMessageModal
      name={'farm_already_exists'}
      title={t('components.modals.farm_already_exists.title')}
      message={t('components.modals.farm_already_exists.message')}
      buttons={
        <div className="pt-4 text-center">
          <Link to={LOGIN}>
            <button className={css['btn-login']}>
              <FontAwesomeIcon icon={faSignIn} />
              <span>{t('pages.external.homepage.login')}</span>
            </button>
          </Link>
        </div>
      }
      onClose={onClose}
    />
  );
}
